import { useDispatch, useSelector } from "react-redux";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { PRODUCT_RATING, IMAGE_ADDRESS } from '../../../../../../apis';
import TrcuckPng from "../../../../../../styles/images/png/truck.png";
import apiRequest from '../../../../../../utils/apiRequest';
import { handleChangeDataOrderDetails } from '../../../../../../redux/actions/pages/user/orderDetails';
import { handleChangeDataModalProductRating } from '../../../../../../redux/actions/partials/modals/modalProductRating';



const CardOrderDetailsConsignment = (props) => {

	const dispatch = useDispatch();

	const { isMobile } = useSelector(state => state.general);
	const { isBackdropLoading } = useSelector(state => state.allLoaders);
	const { token } = useSelector(state => state.login);
	const { content } = useSelector(state => state.orderDetails);

	const statusPercent = props.data.status === 'pending' ? '33%' : (props.data.status === 'shipped' ? '66%' : (props.data.status === 'delivered' ? '100%' : '0%'));

	const totalConsignmentPrice = props.data.products.reduce((sum, product) => {
	    // حذف کاما و تبدیل unitPrice به عدد
	    const unitPrice = parseFloat(product.unitPrice.replace(/,/g, ''));
	    // تبدیل qty به عدد
	    const qty = parseFloat(product.qty);
	    return sum + (unitPrice * qty);
	}, 0);

	const handleClickRateStar = (slug, rate) => {
		if(! isBackdropLoading) {
			apiRequest({
			    dispatch,
			    endpoint: PRODUCT_RATING,
			    method: 'post',
			    data: {uniqueCode: props.data.uniqueCode, slug, rate, type: 'rate'},
			    token: token, 
			    successMessage: 'امتیاز شما با موفقیت ثبت شد',
			    onSuccess: (res) => {
			    	let newContent = content;
			    	content.consignments.map((consignment, key) => {
			    		if(consignment.uniqueCode === props.data.uniqueCode) {
			    			consignment.products.map((product) => {
			    				if(product.slug === slug)
			    					product.rate = rate;
			    			})
			    		}
			    	});

			    	dispatch(handleChangeDataOrderDetails('content', newContent));
			    },
		  	});
		}
	};


	const handleShowModalRating = (product) => {
		dispatch(handleChangeDataModalProductRating('uniqueCode', props.data.uniqueCode));
		dispatch(handleChangeDataModalProductRating('product', product));
		dispatch(handleChangeDataModalProductRating('isOpen', true));
        setTimeout(() => dispatch(handleChangeDataModalProductRating('isActive', true)), 0);
	};

	const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};

    return (
    	
    	<div className="lg:p-4 flex flex-col gap-y-2 lg:gap-y-4">
			<div className="lg:rounded-medium lg:border-complete-200 overflow-hidden bg-neutral-000 px-2">
				<div className="w-full flex flex-col items-stretch gap-3 lg:gap-0 lg:grid lg:grid-cols-2 lg:gap-y-4 pt-4 lg:p-4 lg:border-complete-b-200 w-full pl-0">
					<div className="px-3 lg:px-0 lg:text lg:text-sm text-neutral-900 font-bold flex items-center gap-3">
						<div className="text-body2-strong text-neutral-900 flex items-center gap-1 justify-start">
							<span>مرسوله
							</span>
							<span>{toPersianDigits(props.num)}
							</span>
							<span>از
							</span>
							<span>{toPersianDigits(props.size)}
							</span>
						</div>
						<div className="hidden lg:inline-block text-neutral-200">
							<div className="flex">
								<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-disable)'}}>
									<use xlinkHref="#dotOutline" />
								</svg>
							</div>
						</div>
						<div className="px-3 lg:px-0 flex items-center justify-start gap-2 hidden lg:flex">
							<div className="flex flex-row items-center " style={{color: 'rgb(239, 57, 78)'}}>
								<div>
									<div className="w-5 h-5 ml-2" style={{width: '18px', height: '18px', lineHeight: 0}}>
										<img className="w-full inline-block" src={TrcuckPng} width={18} height={18} alt="" title style={{objectFit: 'contain'}} />
									</div>
								</div>
								<p className="text-body2-strong">{props.data.shippingTypeTxt}
								</p>
							</div>
							<div className="lg:hidden text-neutral-200">
								<div className="flex">
									<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-disable)'}}>
										<use xlinkHref="#dotOutline" />
									</svg>
								</div>
							</div>
							<div className="text-body1 text-neutral-500 lg:hidden">{toPersianDigits(props.data.products.length)} کالا
							</div>
						</div>
						<div className="text-body-2 text-secondary-500 mr-auto cursor-pointer lg:hidden" />
					</div>
					<div className="px-3 lg:px-0 flex items-center justify-start gap-2 lg:hidden">
						<div className="flex flex-row items-center " style={{color: 'rgb(239, 57, 78)'}}>
							<div>
								<div className="w-5 h-5 ml-2" style={{width: '18px', height: '18px', lineHeight: 0}}>
									<span className="w-full inline-block" style={{display: 'inline-block', objectFit: 'contain', width: '18px', height: '18px'}} />
								</div>
							</div>
							<p className="text-body2-strong">{props.data.shippingTypeTxt}
							</p>
						</div>
						<div className="lg:hidden text-neutral-200">
							<div className="flex">
								<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-disable)'}}>
									<use xlinkHref="#dotOutline" />
								</svg>
							</div>
						</div>
						<div className="text-body1 text-neutral-500 lg:hidden">{toPersianDigits(props.data.products.length)} کالا
						</div>
					</div>
					<div className="lg:flex lg:justify-end Parcel_Parcel__progress__XgKlT">
						<div className="relative w-full rounded-medium p-3 pb-4 ShippingProgress_ShippingProgress__jhQbT">
							<div className={`absolute w-full h-full rounded-medium left-0 top-0 z-0 ${isMobile ? 'bg-hint-object-success' : ''} ShippingProgress_ShippingProgress__opacityLow__JlECT`} />
							<div className="relative">
								<div className="flex flex-row justify-between items-center relative mb-2">
									<h6 className="text-body2-strong font-bold text-hint-text-success">
										<div className="text-body1-strong">{props.data.statusTxt}
										</div>
									</h6>
									<div className="hidden lg:block" />
								</div>
								<div className="bg-neutral-200 lg:bg-neutral-100 w-full rounded-large lg:rounded-large relative z-1 ShippingProgress_ShippingProgress__progressBarHeight__OlP6L">
									<div className="rounded-large relative right-0 bg-hint-object-success ShippingProgress_ShippingProgress__progressBarHeight__OlP6L" style={{width: `${statusPercent}`}}>
										<div className="lg:hidden text-neutral-000 flex justify-center items-center absolute px-2 lg:px-1 h-full top-0 left-0">
											<div className="flex">
												<svg style={{width: '8px', height: '8px', fill: 'var(--color-icon-white)'}}>
													<use xlinkHref="#done" />
												</svg>
											</div>
										</div>
									</div>
								</div>
								<div className="mt-2 lg:hidden" />
							</div>
						</div>
					</div>
					<div className="px-3 lg:px-0 flex items-center gap-1 justify-between lg:justify-start lg:place-self-end lg:self-start  lg:mr-auto Parcel_Parcel__code__WAOyz">
						<div className="text-neutral-500 text-body-1 whitespace-nowrap">کد پیگیری مرسوله
							<span className="hidden lg:inline">:
							</span>
						</div>
						<div className="text-neutral-900 text-body1-strong flex items-center gap-1">
							<span className="text-body-2">{toPersianDigits(props.data.uniqueCode)}
							</span>
						</div>
					</div>
					<div className="px-3 lg:px-0 flex items-center gap-1 justify-between lg:justify-start Parcel_Parcel__date__vIGoF">
						<div className="text-neutral-500 text-body-1 whitespace-nowrap">زمان تحویل
							<span className="hidden lg:inline">:
							</span>
						</div>
						<div className="text-neutral-900 text-body1-strong flex items-center gap-1">{toPersianDigits(props.data.deliveryDate)} بازه {toPersianDigits(props.data.deliveryTime)}
						</div>
					</div>
					<div className="lg:flex items-center gap-3 Parcel_Parcel__priceBox__vfk47">
						<div className="px-3 lg:px-0 flex items-center gap-1 justify-between lg:justify-start Parcel_Parcel__priceBox--shippingPrice__4CEQa">
							<div className="text-neutral-500 text-body-1 whitespace-nowrap">هزینه ارسال
								<span className="hidden lg:inline">:
								</span>
							</div>
							<div className="text-neutral-900 text-body1-strong flex items-center gap-1">{toPersianDigits(props.data.price)}
								<div className="flex">
									<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-high-emphasis)'}}>
										<use xlinkHref="#toman" />
									</svg>
								</div>
							</div>
						</div>
						<div className="hidden lg:block text-neutral-200">
							<div className="flex">
								<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-disable)'}}>
									<use xlinkHref="#dotOutline" />
								</svg>
							</div>
						</div>
						<div className="px-3 lg:px-0 flex items-center gap-1 justify-between lg:justify-start Parcel_Parcel__priceBox--totalPrice__JT1eK">
							<div className="text-neutral-500 text-body-1 whitespace-nowrap">مبلغ مرسوله
								<span className="hidden lg:inline">:
								</span>
							</div>
							<div className="text-neutral-900 text-body1-strong flex items-center gap-1">{toPersianDigits(totalConsignmentPrice.toLocaleString())}
								<div className="flex">
									<svg style={{width: '12px', height: '12px', fill: 'var(--color-icon-high-emphasis)'}}>
										<use xlinkHref="#toman" />
									</svg>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="px-3 mt-5 lg:mt-0">
				{
					props.data.products.map((product, key) => (
						<div className={`py-4 ${key + 1 < props.data.products.length ? 'border-complete-b-200' : ''}`}>
							<div className="bg-neutral-000 py-4 lg:pr-4 mx-4 lg:mx-0" data-testid="cart-item">
								<div className="styles_CartItem__grid__rZXPE">
									<div className="flex flex-col items-center">
										<a className="relative" target="_blank" href={`/product/${product.slug}/${product.title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`}>
											<div style={{width: '114px', height: '114px', lineHeight: 0}}>
												<picture>
													<LazyLoadImage className="w-full inline-block" src={IMAGE_ADDRESS + product.image} width={114} height={114} alt={product.title} title style={{objectFit: 'contain'}} />
												</picture>
											</div>
											<div className="bg-neutral-000 absolute bottom-0 left-0 rounded-small text-center text-neutral-900 text-caption-strong styles_CartItem__imageQuantity__bzt41">۱
											</div>
										</a>
										<div className="mr-2" />
									</div>
									<div className="overflow-x-hidden">
										<div className>
											<h3 className="text-neutral-800 text-body1-strong mb-2">{product.title}
											</h3>
											<div className="flex">
												<div className="flex mt-1">
													<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-low-emphasis)'}}>
														<use xlinkHref="#seller" />
													</svg>
												</div>
												<p className="text-body-2 text-neutral-600 mr-2">{product.sellerTitle}
												</p>
											</div>
										</div>
									</div>
									<div className="flex flex-col items-center" />
									<div>
										{ product.discount !== '0' &&
											<div className="flex items-center text-primary-700">
												<span className="text-caption-strong">{toPersianDigits(product.discount)}
												</span>
												<div className="flex relative styles_CartItem__discountIcon__Vw7DV">
													<svg style={{width: '14px', height: '14px', fill: 'var(--color-icon-primary)'}}>
														<use xlinkHref="#toman" />
													</svg>
												</div>
												<span className="text-caption mr-1">تخفیف
												</span>
											</div>
										}
										<div className="flex items-center justify-between">
											<div>
												<div className="flex items-center justify-start ml-4">
													<div className="flex justify-start items-center gap-1">
														<span className="text-h4 text-neutral-800">{toPersianDigits(product.unitPrice)}
														</span>
													</div>
													<div className="flex items-center justify-between">
														<div className="flex items-center">
															<div className="flex">
																<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-high-emphasis)'}}>
																	<use xlinkHref="#toman" />
																</svg>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div className="flex a-center flex-row-reverse ml-4" />
										</div>
									</div>
								</div>
								<div className="mt-3 flex gap-2 flex-wrap" />
								
								{ props.data.status === 'delivered' &&
								<div className="flex flex-col lg:flex-row mt-4">
									<div className="lg:min-w-1/3 lg:max-w-[40%] w-full">
										<div className="flex items-center justify-between">
											<p className="text-body2-strong">امتیاز دهید!
											</p>
											<div className="gap-3 flex">
												<div className="flex flex-col items-center">
													<div onClick={() => handleClickRateStar(product.slug, 1)} className="flex cursor-pointer">
														<svg style={{width: '24px', height: '24px', fill: `${product.rate !== null && product.rate >= '1' ? 'var(--color-icon-warning)' : 'var(--color-icon-low-emphasis)'}`}}>
															<use xlinkHref={`#${product.rate !== null && product.rate >= '1' ? 'starFill' : 'starOutline'}`} />
														</svg>
													</div>
													<p className="text-body-2-compact text-neutral-500">۱
													</p>
												</div>
												<div className="flex flex-col items-center">
													<div onClick={() => handleClickRateStar(product.slug, 2)} className="flex cursor-pointer">
														<svg style={{width: '24px', height: '24px', fill: `${product.rate !== null && product.rate >= '2' ? 'var(--color-icon-warning)' : 'var(--color-icon-low-emphasis)'}`}}>
															<use xlinkHref={`#${product.rate !== null && product.rate >= '2' ? 'starFill' : 'starOutline'}`} />
														</svg>
													</div>
													<p className="text-body-2-compact text-neutral-500">۲
													</p>
												</div>
												<div className="flex flex-col items-center">
													<div onClick={() => handleClickRateStar(product.slug, 3)} className="flex cursor-pointer">
														<svg style={{width: '24px', height: '24px', fill: `${product.rate !== null && product.rate >= '3' ? 'var(--color-icon-warning)' : 'var(--color-icon-low-emphasis)'}`}}>
															<use xlinkHref={`#${product.rate !== null && product.rate >= '3' ? 'starFill' : 'starOutline'}`} />
														</svg>
													</div>
													<p className="text-body-2-compact text-neutral-500">۳
													</p>
												</div>
												<div className="flex flex-col items-center">
													<div onClick={() => handleClickRateStar(product.slug, 4)} className="flex cursor-pointer">
														<svg style={{width: '24px', height: '24px', fill: `${product.rate !== null && product.rate >= '4' ? 'var(--color-icon-warning)' : 'var(--color-icon-low-emphasis)'}`}}>
															<use xlinkHref={`#${product.rate !== null && product.rate >= '4' ? 'starFill' : 'starOutline'}`} />
														</svg>
													</div>
													<p className="text-body-2-compact text-neutral-500">۴
													</p>
												</div>
												<div className="flex flex-col items-center">
													<div onClick={() => handleClickRateStar(product.slug, 5)} className="flex cursor-pointer">
														<svg style={{width: '24px', height: '24px', fill: `${product.rate !== null && product.rate >= '5' ? 'var(--color-icon-warning)' : 'var(--color-icon-low-emphasis)'}`}}>
															<use xlinkHref={`#${product.rate !== null && product.rate >= '5' ? 'starFill' : 'starOutline'}`} />
														</svg>
													</div>
													<p className="text-body-2-compact text-neutral-500">۵
													</p>
												</div>
											</div>
										</div>
									</div>
									<button onClick={() => handleShowModalRating(product)} className="font-iran-yekan relative flex items-center user-select-none styles_btn__Q4MvL text-button-2 styles_btn--outlined__saFC3 styles_btn--primary__y0GEv rounded-medium px-4 py-1 mr-auto lg:w-1/5 w-full lg:mt-0 mt-2" data-cro-id="profile-add-comment">
										<div className="flex items-center justify-center relative grow">
											<div className="flex ml-2">
												<svg style={{width: '24px', height: '24px', fill: 'var(--color-icon-primary)'}}>
													<use xlinkHref="#comment" />
												</svg>
											</div>ثبت دیدگاه
										</div>
									</button>
								</div>
								}

							</div>
							<div className="gap-2 flex flex-wrap" />
						</div>
					))
				}
				</div>
				<div className />
			</div>
		</div>

    );
}

export default CardOrderDetailsConsignment;